import { BetPoint, createCashoutHistoryService } from "@tipico/jack-time";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { JACKTIME_HISTORY_URL } from "../env-config";

export interface CashoutData {
    readonly currentCashout?: number;
    readonly currentTimestamp?: number;
    readonly data: BetPoint[];
    readonly max?: number;
    readonly min?: number;
    readonly isBlocked: boolean;
    readonly isError: boolean;
}

export function handleCashoutData(betId: number): Observable<CashoutData> {
    const getCashoutValues = (data: BetPoint[]) =>
        data.map(betPoint => betPoint.cashoutValue);

    return createCashoutHistoryService({
        baseUrl:
            JACKTIME_HISTORY_URL + "/bet/{BET_ID}?starting-index={LAST_INDEX}",
        fetchInterval: 5000
    })
        .forBet(betId)
        .pipe(
            map(data => {
                if (data.length > 0) {
                    const values = getCashoutValues(data);
                    return {
                        currentCashout: values[values.length - 1],
                        currentTimestamp: Number(
                            data[data.length - 1].timestamp
                        ),
                        data,
                        isBlocked: data[data.length - 1].blockedForSell,
                        isError: false,
                        max: Math.max(...values),
                        min: Math.min(...values)
                    };
                } else {
                    return {
                        data,
                        isBlocked: false,
                        isError: true
                    };
                }
            })
        );
}
